import { State as StateDef, ResolveTypegenMeta, BaseActionObject } from 'xstate';
import type * as RelatedSlide from './relatedSlide.types';
import { StateTags } from './relatedSlide.types';
import { Typegen0 } from './relatedSlide.machine.typegen';

// [NOTE] - Normally we can use some util helpers, other TS access to get this
//          but it's possible to run into a circular dependency error when using selector as machine guards
//        - This probably creates a 2nd instance of the State type but it's needed for now
type State = StateDef<
  RelatedSlide.SMContext,
  RelatedSlide.SMEvents,
  any,
  { value: any, context: RelatedSlide.SMContext },
  ResolveTypegenMeta<
    Typegen0,
    RelatedSlide.SMEvents,
    BaseActionObject,
    RelatedSlide.SMServices
  >
>

// TAGS
export const isLoading = (state: State) => ({ isLoading: state.tags.has(StateTags.LOADING) })

// CHECK STATE
export const isIdleState = (state: State) => ({ isIdleState: state.matches('idle') })
export const isPresentingState = (state: State) => ({ isPresentingState: state.matches('presenting') })
export const isPresentingResult = (state: State) => {
  const _isPresentingState = isPresentingState(state).isPresentingState;
  const _currentRelatedSlides = currentRelatedSlides(state).currentRelatedSlides;
  return { isPresentingResult: _isPresentingState && !!_currentRelatedSlides.length }
}
export const isPresentingNoResult = (state: State) => {
  const _isPresentingState = isPresentingState(state).isPresentingState;
  const _currentRelatedSlides = currentRelatedSlides(state).currentRelatedSlides;
  return { isPresentingNoResult: _isPresentingState && !_currentRelatedSlides.length }
}
export const isOfflineState = (state: State) => ({ isOfflineState: state.matches('offline') })
export const isErrorState = (state: State) => ({ isErrorState: state.matches('error') })

// CONTEXT
export const currentPageId = (state: State) => ({ currentPageId: state.context.currentPageId })
export const currentRelatedSlides = (state: State) => {
  const { currentPageId, relatedSlides } = state.context;

  return {
    currentRelatedSlides: currentPageId
      ? relatedSlides[currentPageId] ?? []
      : [],
  }
}
